import { Button } from "@svea/design-system-components-react";
import { QuestionSet, type QuestionSetItem, useText } from "@sveabank/cc-common";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { usePageContext } from "../../hooks/context";
import { resetPossibleGuarantors } from "../../slices/guarantorSlice";
import type { AppDispatch } from "../../store";
import AddGuarantorSection from "./add-guarantor-section";
import CustomerAgreementSection from "./customer-agreement-section";
import GuarantorSection from "./guarantor-section";
import { useSignInformation } from "./hooks/hooks";
import ResetFlowWarningModal from "./reset-flow-warning-modal";

const CreditSignFlow = () => {
	const dispatch = useDispatch<AppDispatch>();

	const [t, texts] = useText();

	const {
		isAssignGuarantorsCompleted,
		isSignPackageCompleted,
		isSignGuarantorsCompleted,
		removeAllGuarantors,
		isCurrentUserApplicant,
		agreementStepHasModalOpen,
		guarantorStepHasModalOpen,
	} = usePageContext(useSignInformation);

	const [isChangeGuarantorModalOpen, setIsChangeGuarantorModalOpen] = useState(false);

	const signSteps: QuestionSetItem[] = [
		{
			component: <AddGuarantorSection />,
			heading: t(texts.signPage.guarantors.title),
			description: "",
			isCompleted: isAssignGuarantorsCompleted,
		},
		{
			component: <CustomerAgreementSection />,
			heading: t(texts.signPage.signing.agreementSigning.title),
			description: "",
			isCompleted:
				isSignPackageCompleted && isAssignGuarantorsCompleted && !agreementStepHasModalOpen,
		},
		{
			component: <GuarantorSection />,
			heading: t(texts.signPage.signing.guarantorSign.title),
			description: "",
			isCompleted:
				isSignPackageCompleted &&
				isAssignGuarantorsCompleted &&
				isSignGuarantorsCompleted &&
				!guarantorStepHasModalOpen,
		},
	];

	const handleChangeGuarantors = async () => {
		await removeAllGuarantors();
		dispatch(resetPossibleGuarantors());
		setIsChangeGuarantorModalOpen(false);
	};

	return (
		<>
			{isAssignGuarantorsCompleted && isCurrentUserApplicant && (
				<div className="flex justify-end">
					<Button
						type="button"
						iconStart="trash"
						variant="plain"
						onPress={() => {
							setIsChangeGuarantorModalOpen(true);
						}}
					>
						{t(texts.signPage.resetGuarantorFlowModal.acceptButton)}
					</Button>
				</div>
			)}

			<QuestionSet questions={signSteps} isEditable={false} />

			{isChangeGuarantorModalOpen && (
				<ResetFlowWarningModal
					isOpen={isChangeGuarantorModalOpen}
					setOpen={setIsChangeGuarantorModalOpen}
					handleAccept={handleChangeGuarantors}
					closeButtonText={t(texts.signPage.addGuarantorModal.closeButton)}
					acceptButtonText={t(texts.signPage.resetGuarantorFlowModal.acceptButton)}
					title={t(texts.signPage.resetGuarantorFlowModal.title)}
					description={t(texts.signPage.resetGuarantorFlowModal.description)}
				/>
			)}
		</>
	);
};

export default CreditSignFlow;
